// Handoff Lookbook Order Shopify
export const HANDOFF_LOOKBOOK_ORDER_SHOPIFY_REQUEST = 'HANDOFF_LOOKBOOK_ORDER_SHOPIFY_REQUEST';
export const HANDOFF_LOOKBOOK_ORDER_SHOPIFY_DONE = 'HANDOFF_LOOKBOOK_ORDER_SHOPIFY_DONE';
export const HANDOFF_LOOKBOOK_ORDER_SHOPIFY_FAILED = 'HANDOFF_LOOKBOOK_ORDER_SHOPIFY_FAILED';
export const HANDOFF_LOOKBOOK_ORDER_SHOPIFY_CLEAR_ERRORS = 'HANDOFF_LOOKBOOK_ORDER_SHOPIFY_CLEAR_ERRORS';
export const HANDOFF_LOOKBOOK_ORDER_SHOPIFY_RESET = 'HANDOFF_LOOKBOOK_ORDER_SHOPIFY_RESET';
